import unescape from 'helpers/unescape';

angular.module('gym.components').directive('stripeServiceAgreement', function() {
  return {
    restrict: 'EA',
    template: require('templates/components/waivers/stripe_service_agreement.html.slim'),
    controller: ["$scope", "$rootScope", function($scope, $rootScope) {
      var ref;
      return $scope.gymName = ((ref = $rootScope.gym) != null ? ref.name : void 0) || unescape(window.DATA.gym_name);
    }]
  };
});
